import {ActionReducerMap} from '@ngrx/store';
import * as reducers from './reducers';

export interface AppState {
  usrRdx: reducers.UsuarioState,
  empresa: reducers.Empresa;
}

export const appReducers: ActionReducerMap<AppState> = {
  usrRdx: reducers.usuarioReducer,
  empresa: reducers.empresaReducer,
}
